import React from 'react';

export default function SkipLink(props) {
  return (
    <a
      className="skipLink"
      href="#main"
    >
      Skip to Main Content
    </a>
  )
}



// WEBPACK FOOTER //
// ./src/client/components/nav/skip-link.jsx